export const GRAVES_ON_DELETE_REQUESTED = 'GRAVES_ON_DELETE_REQUESTED';
export const GRAVES_ON_DELETE_SUCCEEDED = 'GRAVES_ON_DELETE_SUCCEEDED';
export const GRAVES_ON_DELETE_FAILED = 'GRAVES_ON_DELETE_FAILED';

export const GRAVES_ON_GET_ALL_REQUESTED = 'GRAVES_ON_GET_ALL_REQUESTED';
export const GRAVES_ON_GET_ALL_SUCCEEDED = 'GRAVES_ON_GET_ALL_SUCCEEDED';
export const GRAVES_ON_GET_ALL_FAILED = 'GRAVES_ON_GET_ALL_FAILED';

export const GRAVES_ON_GET_FORM_REQUESTED = 'GRAVES_ON_GET_FORM_REQUESTED';
export const GRAVES_ON_GET_FORM_SUCCEEDED = 'GRAVES_ON_GET_FORM_SUCCEEDED';
export const GRAVES_ON_GET_FORM_FAILED = 'GRAVES_ON_GET_FORM_FAILED';

export const GRAVES_ON_GET_ONE_REQUESTED = 'GRAVES_ON_GET_ONE_REQUESTED';
export const GRAVES_ON_GET_ONE_SUCCEEDED = 'GRAVES_ON_GET_ONE_SUCCEEDED';
export const GRAVES_ON_GET_ONE_FAILED = 'GRAVES_ON_GET_ONE_FAILED';

export const GRAVES_ON_SAVE_REQUESTED = 'GRAVES_ON_SAVE_REQUESTED';
export const GRAVES_ON_SAVE_SUCCEEDED = 'GRAVES_ON_SAVE_SUCCEEDED';
export const GRAVES_ON_SAVE_FAILED = 'GRAVES_ON_SAVE_FAILED';
